import createBox from '../createBox';
var Box = createBox();
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Box;